module.exports = __webpack_public_path__ + "img/011-wind-3.6f30fb83.svg";